import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';
import { getSiteConfiguration } from '../../features/Configuration/configurationAction';
import { getFeatureUsageAccounts } from '../../features/FeatureUsage/featureUsageAction';
import { AccountListHeader, AccountListFilters } from '../../modules/AccountList';
import { getAccountsWithLicenseList, getFeaturesList } from '../../features';
import styles from '../../layouts/pages/style';
import useStyles from '../../hooks/useStyles';
import useAccountList from './useAccountList';
import AccountDetailsTable from '../@dashboard/account-details/accountDetailsTable';
import { featureUsageModeConst } from './accountListConfig';

function AccountList({ permissions }) {
  const dispatch = useDispatch();
  const location = useLocation();

  const { id: accountListMenuId } = useParams();

  const {
    filters = {},
    showAdvanceFilter = false,
    isNavigatedFromRiskAccount = false,
    isNavigatedFromAccountDashboard = false,
    isNavigatedFromFeatureTaxonomy = false,
    featureAccountsQueryData = null,
  } = location?.state || { filters: { accountVisibility: true, licenceStatus: ['Active'] } };

  const hookParams = {
    pathname: location?.pathname, filters, showAdvanceFilter, isNavigatedFromRiskAccount, isNavigatedFromAccountDashboard, isNavigatedFromFeatureTaxonomy, accountListMenuId,
  };

  const {
    accountList,
    filteredAccounts,
    featureList,
    selectedFilters,
    setSelectedFilters,
    resetFilters,
    toggleAdvanceFilters,
    setToggleAdvanceFilters,
    findSelectedView,
    openDialog,
    setOpenDialog,
    selectedView,
    setSelectedView,
  } = useAccountList(hookParams);

  const siteConfiguration = useSelector((state) => state.siteConfiguration?.data);

  useEffect(() => {
    if (isNavigatedFromFeatureTaxonomy && featureAccountsQueryData) {
      dispatch(getFeatureUsageAccounts(featureAccountsQueryData));
    }
  }, [isNavigatedFromFeatureTaxonomy, featureAccountsQueryData]);

  useEffect(() => {
    dispatch(getAccountsWithLicenseList());
    dispatch(getFeaturesList());
    dispatch(getSiteConfiguration());
    if (selectedFilters.featureUsageMode === featureUsageModeConst.DONT_USE) {
      dispatch(getFeatureUsageAccounts());
    }
  }, []);

  useEffect(() => {
    if (selectedFilters.featureUsageFilter.length) {
      dispatch(getFeatureUsageAccounts({
        featureId: selectedFilters.featureUsageFilter.map((item) => item.value),
      }));
    }
  }, [selectedFilters.featureUsageFilter]);

  const classes = useStyles(styles)();
  return (
    <Grid container gap={2}>
      <Grid item xs={12} className={classes.cardStyles}>
        <AccountListHeader
          isLicense={false}
          classes={classes}
          accountList={filteredAccounts}
          selectedView={selectedView}
          setSelectedView={setSelectedView}
          findSelectedView={findSelectedView}
        />
      </Grid>

      <Grid item container xs={12} className={['tg-filters', classes.cardStyles]} gap={2}>
        <AccountListFilters
          classes={classes}
          accountList={accountList?.data}
          featureList={featureList}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          resetFilters={resetFilters}
          toggleAdvanceFilters={toggleAdvanceFilters}
          setToggleAdvanceFilters={setToggleAdvanceFilters}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          selectedView={selectedView}
          setSelectedView={setSelectedView}
          findSelectedView={findSelectedView}
        />
      </Grid>

      <Grid item xs={12} className={classes.tableStyles}>
        {filteredAccounts?.length ? <AccountDetailsTable isLicense={false} siteConfiguration={siteConfiguration} AccountTableData={filteredAccounts} permissions={permissions} selectedFilters={selectedFilters} accountListMenuId={accountListMenuId} /> : null}
      </Grid>
    </Grid>
  );
}
export default AccountList;
